
export type VideoCodec = 'h264' | 'vp9'

export type StoredVideoTranscodeConfig = {
    transcodingEnabled: boolean
    transcodeExtensions: string[]
    outputCodec: VideoCodec
    crf: number
    maxOutputWidth: number
    maxUploadBytes: number
    allowedTypes: AllowedUploadType[]
}

export const DEFAULT_VIDEO_TRANSCODE_CONFIG: StoredVideoTranscodeConfig = {
    transcodingEnabled: true,
    transcodeExtensions: ['mp4', 'webm', 'mov'],
    outputCodec: 'h264',
    crf: 23,
    maxOutputWidth: 1920,
    maxUploadBytes: 250 * 1024 * 1024,
    allowedTypes: [
        { extension: 'mp4', mimetypes: ['video/mp4'] },
        { extension: 'webm', mimetypes: ['video/webm'] },
        {
            extension: 'mov',
            mimetypes: [
                'video/quicktime',
                'video/x-quicktime',
                'video/mov',
                'video/mp4',
            ],
        },
    ],
}
